export const NODE_TYPE_ROOT = 'root';
export const NODE_TYPE_GROUP = 'group';
export const NODE_TYPE_QUESTION = 'question';
export const NODE_TYPE_QUESTION_MULTIPLE = 'question_multiple';
export const NODE_TYPE_CONTENT = 'content';
export const NODE_TYPE_TICKET_SELECTION = 'ticketSelectionNode';
